
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-f71484be&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CategoryPopover.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CategoryPopover.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-f71484be!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CategoryPopover.vue"),
  /* scopeId */
  "data-v-f71484be",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/popover/CategoryPopover.vue
// module id = 601
// module chunks = 0